export const environment = {
  firebaseConfig: {
    apiKey: 'AIzaSyAkOQt3IJgNzBjyyqqFaMbkbLRCMVNhS20',
    authDomain: 'verster-troue.firebaseapp.com',
    projectId: 'verster-troue',
    storageBucket: 'verster-troue.firebasestorage.app',
    messagingSenderId: '426044882376',
    appId: '1:426044882376:web:d39898e001a8dd9eeb94fd',
    measurementId: 'G-6HQ4MBDVSV',
  },
};
